import React from 'react';

const Text = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path d="M 19.94,5.985 L 25.917,11.965 L 10.080,27.869 L 4.083,27.819 L 4.103,21.889 Z M 5.367,26.55 L 9.553,26.585 L 24.109,11.966 L 19.941,7.797 L 5.381,22.419 Z M 5.367,26.55M 26.573,11.21 L 20.622,5.259 L 23.637,2.229 L 25.037,2.238 L 29.569,6.675 L 29.588,8.18 Z M 22.43,5.257 L 26.57,9.397 L 28.301,7.658 L 28.296,7.219 L 24.512,3.515 L 24.165,3.512 Z M 22.43,5.257" />
  </svg>
);

export default Text;
